import { Field } from 'redux-form';

import { TextField } from 'common/components/forms';
import BirthDateFormFields from 'common/components/forms/BirthDateFormFields';
import { getDefaultCountryCode } from 'common/helpers/miscHelper';
import { phoneNormalize } from 'common/helpers/phoneHelper';

import AddressFormBlock from './components/AddressFormBlock';

const AddressForm = (props) => {
  const { object, changeFunction, type, settings } = props;
  return (
    <>
      <BirthDateFormFields
        name="birthDate"
        countryCode={getDefaultCountryCode(settings)}
      />
      <div className="c7-form__group">
        <Field
          name="firstName"
          component={TextField}
          label="First Name"
          autocomplete="given-name"
          required
        />
        <Field
          name="lastName"
          component={TextField}
          label="Last Name"
          autocomplete="family-name"
          required
        />
      </div>
      <AddressFormBlock
        countryCode={object.countryCode}
        change={changeFunction}
        type={type}
        settings={settings}
      />
      <Field
        name="phone"
        component={TextField}
        label="Phone"
        autocomplete="tel-national"
        formType="tel"
        normalize={phoneNormalize}
        required
      />
    </>
  );
};

export default AddressForm;
